/* The parts of an environment's Security group, in menu order. Kept apart from the (lazily loaded) Security pane. */

export const SECURITY_PARTS = ["overview", "updates", "malware", "access", "wordpress", "bots", "rules", "firewall", "headers", "activity"] as const;
export type SecurityPart = (typeof SECURITY_PARTS)[number];
export const isSecurityPart = (p: string | undefined | null): p is SecurityPart => (SECURITY_PARTS as readonly string[]).includes(p ?? "");

/** Old addresses: Logins became the WordPress part (logins, XML-RPC, the file editor and the rest of WordPress's own). */
const OLD_PARTS: Record<string, SecurityPart> = { logins: "wordpress" };
/** The part an address names, old names included; anything else is the overview. */
export const securityPartOf = (p: string | undefined | null): SecurityPart => (isSecurityPart(p) ? p : (OLD_PARTS[p ?? ""] ?? "overview"));

/** The parts a site has: WordPress is WordPress's own; Updates is "Vulnerabilities" without WordPress. */
export function securityParts(wp: boolean): { id: SecurityPart; label: string }[] {
  return [
    { id: "overview", label: "Overview" },
    { id: "updates", label: wp ? "Updates & vulnerabilities" : "Vulnerabilities" },
    { id: "malware", label: "Malware" },
    { id: "access", label: "Access" },
    ...(wp ? [{ id: "wordpress" as const, label: "WordPress" }] : []),
    { id: "bots", label: "Bots & rate limits" },
    { id: "rules", label: "Custom rules" },
    { id: "firewall", label: "Firewall" },
    { id: "headers", label: "Headers & HTTPS" },
    { id: "activity", label: "Activity" },
  ];
}
